import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarReceitasDs } from "../../DataSources";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";

const localStorageKey = "cadastroReceitasGridState";

export default class ReceitasBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    console.log(props);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.formaPagto = [
      { id: "0", descricao: "DAM" },
      { id: "1", descricao: "Boleto Bancário" },
    ];
    this.tipoReceita = [
      { id: "0", descricao: "Receita" },
      { id: "1", descricao: "Sub-Receita" },
      { id: "2", descricao: "Receita de encargos" },
    ];
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("receitas/editar/" + e.data.id);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (
      filtro.sequencial !== undefined &&
      filtro.sequencial !== null &&
      filtro.sequencial !== ""
    ) {
      filtroCorrente.push(["sequencial", "contains", filtro.sequencial]);
    }
    if (
      filtro.descricao !== undefined &&
      filtro.descricao !== null &&
      filtro.descricao !== ""
    ) {
      filtroCorrente.push(["descricao", "contains", filtro.descricao.trim()]);
    }
    if (
      filtro.origem !== undefined &&
      filtro.origem !== null &&
      filtro.origem !== ""
    ) {
      filtroCorrente.push(["origem", "contains", filtro.origem.trim()]);
    }

    this._gridInstance.instance.filter(filtroCorrente);
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form id="frmPesquisa" formData={this.state.filtro} colCount={9}>
              <SimpleItem
                dataField="sequencial"
                editorType={"dxNumberBox"}
                editorOptions={{ step: 0, value: null }}
                colSpan={2}
              >
                <Label text="Código da Receita" />
              </SimpleItem>
              <SimpleItem dataField="descricao" colSpan={5}>
                <Label text="Descrição" />
              </SimpleItem>
              <SimpleItem dataField="origem" colSpan={2}>
                <Label text="Origem" />
              </SimpleItem>
            </Form>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <br />
          <PaginaToolbar titulo="Receitas" novoCb={this.novaReceita.bind(this)}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarReceitasDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.props.onSelecionado,
                  },
                ]}
              />
              <Column
                dataField={"sequencial"}
                caption={"#"}
                allowEditing={false}
                alignment={"center"}
                width={80}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column
                dataField={"tributaria"}
                caption={"Tributaria"}
                editorType={"dxCheckBox"} 
                width={120}
              />
              <Column dataField={"descricao"} caption={"Descrição"} />
              <Column dataField={"origem"} caption={"Origem"} />
              <Column dataField={"classificacao"} caption={"Classificação"} />
              <Column dataField={"codigoLivro"} caption={"Cód. Livro"} />
              <Column dataField={"formaPagto"} caption={"Forma de Pagamento"}>
                <Lookup
                  dataSource={this.formaPagto}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novaReceita() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("receitas/novo");
  }
}
